import { Box, Text, CircularProgress } from "@chakra-ui/react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { getDate, getMonth } from "../../redux/actions/actions";
// import { announcements } from "../../data";
import { loadAnnouncements } from "../../redux/api_calls/apiCalls";

export default function Announcements() {
    const { announcementsData, isLoading/*, announcementsError*/ } = useSelector(state => state.announcementsState)
    const history = useHistory()
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(loadAnnouncements())
        // eslint-disable-next-line
    }, [])

    return (
        <Box
            w='100%'
            d='flex'
            flexDir='column'
            flex='1'
        >
            <Text
                fontSize='15px'
                color='#222222'
                fontWeight='800'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                mb='1rem'
            >
                ANNOUNCEMENTS
            </Text>

            <Box
                border='1px solid rgba(0, 0, 0, 0.1)'
                borderRadius='10px'
                boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                w='100%'
                bg='#ffffff'
                d='flex'
                flexDir='column'
                px='1rem'
                flex='1'
            >
                {
                    isLoading ? <Box width='100%' d='flex' justifyContent='center' alignItems='center'>
                        <CircularProgress isIndeterminate color='#3e59de' size='50px' />
                    </Box> :
                        !isLoading && announcementsData.length > 0 ? announcementsData.slice(0, 3).map((announcement, idx) => <Box
                            w='100%'
                            d='flex'
                            alignItems='center'
                            py='1rem'
                            borderBottom='1px solid rgba(0, 0, 0, 0.05)'
                            onClick={() => history.push('/announcements')}
                            cursor='pointer'
                            key={idx}
                        >
                            <Box
                                bg='rgba(254, 88, 88, 0.2)'
                                borderRadius='4px'
                                d='flex'
                                flexDir='column'
                                justifyContent='center'
                                alignItems='center'
                                width='49px'
                                height='49px'
                                color='#000000'
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                mr='1rem'
                            >
                                <Text
                                    fontSize='10px'
                                    fontWeight='400'
                                    textTransform='uppercase'
                                >
                                    {getMonth(announcement.start_date)}
                                </Text>
                                <Text
                                    fontSize='18px'
                                    fontWeight='700'
                                >
                                    {getDate(announcement.start_date)}
                                </Text>
                            </Box>
                            <Box
                                color='#000000'
                                fontSize='12px'
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                d='flex'
                                flexDirection='column'
                                flex='1'
                            >
                                <Text fontWeight='700'>
                                    {announcement.title}
                                </Text>
                                <Text fontWeight='400'>
                                    {announcement.description}
                                </Text>

                            </Box>
                        </Box>)
                            : <Box width='100%' d='flex' justifyContent='center' alignItems='center' py='1rem'>
                                <Text
                                    style={{ fontFamily: 'Mulish, sans-serif' }}
                                    fontSize='20px'
                                    fontWeight='600'
                                    color='#222222'
                                >
                                    {/* {announcementsError} */}
                                    No Announcements Yet!
                                </Text>
                            </Box>
                }

            </Box>

        </Box>

    )
}